import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const RestrictedAccess = () => {
  const auth = JSON.parse(localStorage.getItem("tToken"));
  return auth ? <Outlet /> : <Navigate to="/" />;
};
